var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"mr-spinner-veil",class:{ 'full-screen': _vm.fullScreen, 'full-white-out': _vm.fullWhiteOut }},[_c('div',{staticClass:"veil"}),_c('div',{staticClass:"spinner-wrap"},[_c('MrSpinner')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }